import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/integration-exchanges', { params }),
  getStats: params => axios.get('/api/admin/v1/integration-exchanges/stats', { params }),

  getById: id => axios.get(`/api/admin/v1/integration-exchanges/${id}`),
}
